import Modal from '@material-ui/core/Modal'
import React, { FC, useState } from 'react'

import { CrossIcon } from 'uiKit/icons/CrossIcon'
import * as S from './ConfirmDisableLastActiveDataset.style'
import { CButton } from '../../../../../components/CButton'

type ConfirmDisableLastActiveDatasetModalProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => Promise<any>
}

export const ConfirmDisableLastActiveDataset: FC<ConfirmDisableLastActiveDatasetModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const [loading, setLoading] = useState(false)
  const handleDelete = async () => {
    try {
      setLoading(true)
      await onConfirm()
    } catch (e) {
      setLoading(false)
      throw e
    }
  }

  if (!open) return null

  return (
    <Modal open onClose={onClose}>
      <S.Container>
        <S.Title>Are you sure you want to deactivate the last active dataset?</S.Title>
        <S.SubTitle>
          Once deactivated, the chat will no longer have any dataset to use for answering questions. Only trained
          questions will remain available.
        </S.SubTitle>
        <S.SubTitle></S.SubTitle>
        <S.IconWrap onClick={onClose}>
          <CrossIcon color={'var(--color-spun-pearl-grey)'} />
        </S.IconWrap>
        <S.ButtonsWrap>
          <CButton label="Cancel" color="primary" disabled={loading} onClick={onClose} />
          <CButton label="Yes, deactivate" color="danger" disabled={loading} onClick={handleDelete} />
        </S.ButtonsWrap>
      </S.Container>
    </Modal>
  )
}
